import Vue from 'vue'

export default {
    SET_BUSINESS: (state, businesses) => {
        state.items = businesses
    },

    SET_ACCOUNT_ACTIVITY: (state, accountId) => {
        const accountIndex = state.items.findIndex(it => it.businessId === accountId)
        const account = state.items[accountIndex]

        if (accountIndex !== -1) {
            Vue.set(account, 'disabled', !account.disabled)
        }
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    RESET_BUSINESS: (state) => {
        state.filters = {
            businessId: null,
            fromDate: null,
            toDate: null,
            leader: null,
            businessEmail: null,
            query: null
        }
    }
}
